import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../components/styledComponents/Result";
import {
  selectAllowableLoad,
  selectAllowableTestLoad,
  selectLoadType,
  selectTotalDesignLoad,
  selectUltimateLoad,
} from "../../../../store/slices/fhwaSlice";
import { COMPRESSION_PILE } from "../../../../constants";

function AllowableLoadDesignCheck() {
  const { t } = useTranslation("fhwa");

  const designLoad = useSelector(selectTotalDesignLoad);
  const ultimateLoad = useSelector(selectUltimateLoad);

  const allowableLoad = useSelector(selectAllowableLoad);
  var aL_isGreater = allowableLoad.current > designLoad.current;

  const allowableTestLoad = useSelector(selectAllowableTestLoad);
  var aTL_isGreater = allowableTestLoad.current > ultimateLoad.current;

  var ok = t("AllowableLoadDesignCheck_Ok");
  var ng = t("AllowableLoadDesignCheck_Error");

  const loadType = useSelector(selectLoadType);

  var titlekey =
    loadType === COMPRESSION_PILE
      ? "AllowableLoadDesignCheckTest_Compression"
      : "AllowableLoadDesignCheckTest_Tension";

  return (
    <>
      <RowBody
        titleValue={<p>{t("AllowableLoadDesignCheck")}</p>}
        indicesValue={aL_isGreater ? ">" : "<"}
        inputValue={<ResultSpan valid={aL_isGreater}>{aL_isGreater ? ok : ng}</ResultSpan>}
      />
      <RowBody
        titleValue={<p>{t(titlekey)}</p>}
        indicesValue={aTL_isGreater ? ">" : "<"}
        inputValue={<ResultSpan valid={aTL_isGreater}>{aTL_isGreater ? ok : ng}</ResultSpan>}
      />
    </>
  );
}

export default AllowableLoadDesignCheck;
